import React from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

export default (props) => {
  const value = props.data ? props.data[props.colDef.field] : null;
  const id = props.data ? props.data.reportPeriodID : null;
  const reitName = props.data ? props.data.reitName : null;

  return (
    <span>
      <MotifCheckbox
        type="checkbox"
        name="publish-cell-checkbox"
        id={`ag-publish-cell-checkbox-${id}`}
        checked={value}
        tabIndex="-1"
        aria-label="Press Space to toggle row selection"
        onClick={() => props.onCellCheckboxChange(id, props.node)}
        data-testid={`chkPublishTestResult${reitName}`}
      ></MotifCheckbox>
    </span>
  );
};
